import React from 'react'
import './style/FooterMobile.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'


function FooterMobile() {
    return (
        <div className="footerMobile">
            <div> <FontAwesomeIcon icon={faFacebookF} /></div>
            <div> <FontAwesomeIcon icon={faTwitter} /></div>
            <div className="footerMobile__copyright">&copy;<span>  &copy;copyright 2020 Developed By Omar Ghozzi. All rights reserved</span></div>
            <div> <FontAwesomeIcon icon={faInstagram} /></div>
            <div> <FontAwesomeIcon icon={faLinkedinIn} /></div>
        </div>
    )
}

export default FooterMobile
